import Cookies from 'js-cookie';

export function openPartnerCabinet(data) {
  if (!data || typeof data.access_token !== 'string' || !data.access_token) {
    throw new Error(data?.error?.code || 'Failed to login as partner user');
  }

  const local = process.env.NODE_ENV === 'development';
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const cookieDomain = local ? '.bookimed.run' : parts.length >= 2 ? `.${parts.slice(-2).join('.')}` : hostname;
  const tld = hostname.slice(hostname.lastIndexOf('.'));
  const partnerUrl = local ? 'https://partner.bookimed.run/en/LK/profile' : `https://partner.bookimed${tld}/en/LK/profile`;
  const expiresIn = data.expires_in || 3600;

  Cookies.set('agencyToken', data.access_token, { expires: expiresIn / 86400, domain: cookieDomain, path: '/' });
  if (data.refresh_token) {
    Cookies.set('agencyRefreshToken', data.refresh_token, { expires: 1, domain: cookieDomain, path: '/' });
  } else {
    Cookies.remove('agencyRefreshToken', { domain: cookieDomain, path: '/' });
  }
  window.open(partnerUrl, '_blank');
}
